module.exports = __webpack_public_path__ + "media/images/slider/Sichuan-style-poached-sliced-beef-e7b46cf86b3a9a01e1d68bea3fdce2ab.jpg";